module.exports = __webpack_public_path__ + "img/logo-hug-gruppe.cb695d10.svg";